import script from "./TemplateSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateSidebar.vue?vue&type=style&index=0&id=30b858ec&lang=css"

const __exports__ = script;

export default __exports__